import type { PaginatedListParams } from '../types';

const listParamsKey = ({ page, size, search }: PaginatedListParams) => ({
  page,
  size,
  search: search || '',
});

export const queryKeys = {
  members: {
    gymPage: (gymId: string, params: PaginatedListParams) =>
      ['members', 'gym', gymId, listParamsKey(params)] as const,
  },
  trainers: {
    gymPage: (gymId: string, params: PaginatedListParams) =>
      ['trainers', 'gym', gymId, listParamsKey(params)] as const,
  },
  managers: {
    gymPage: (gymId: string, params: PaginatedListParams) =>
      ['managers', 'gym', gymId, listParamsKey(params)] as const,
  },
  programs: {
    trainerIdsPage: (trainerIds: string[], params: PaginatedListParams) =>
      [
        'programs',
        'trainerIds',
        [...trainerIds].sort(),
        listParamsKey(params),
      ] as const,
  },
  templates: {
    trainerPage: (trainerId: string, params: PaginatedListParams) =>
      ['templates', 'trainer', trainerId, listParamsKey(params)] as const,
    gymPage: (gymId: string, params: PaginatedListParams) =>
      ['templates', 'gym', gymId, listParamsKey(params)] as const,
    byIds: (ids: string[]) =>
      ['templates', 'byIds', [...ids].sort().join(',')] as const,
  },
  exercises: {
    mergedTrainerPage: (trainerId: string, params: PaginatedListParams) =>
      ['exercises', 'mergedTrainer', trainerId, listParamsKey(params)] as const,
  },
  groups: {
    idsPage: (groupIds: string[], params: PaginatedListParams) =>
      ['groups', 'ids', [...groupIds].sort(), listParamsKey(params)] as const,
    gymPage: (gymId: string, params: PaginatedListParams) =>
      ['groups', 'gym', gymId, listParamsKey(params)] as const,
  },
};
